import { formatDateToString } from "../../helper/common";
import { FIELD_TYPE } from "../../type/fileType";
import { STATUS } from "../../type/status";

const { COMBO_BOX, INPUT, DATE, SELECT } = FIELD_TYPE;

const fieldsPatient = [
  {
    type: COMBO_BOX,
    label: "Danh sách hợp đồng",
    name: "id",
    rules: [{ required: true, message: "Chưa chọn hợp đồng" }],
    css: { xs: 8, sm: 24, md: 24, lg: 24, xl: 24 },
  },
];

const dataFormReason = [
  {
    type: INPUT,
    label: "Lý do",
    name: "reason",
    rules: [{ required: true, message: "Chưa nhập lý do" }],
    css: { xs: 8, sm: 24, md: 24, lg: 24, xl: 24 },
  },
];

const listColumnsTableCreated = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    align: "center",
  },
  {
    title: "Tên học viên",
    dataIndex: "dataJson",
    key: "name",
    render: (text, record) => {
      const data = JSON.parse(record.dataJson);
      return data.fullname ?? "Không có tên";
    },
  },
  {
    title: "Tên hợp đồng",
    dataIndex: "templateName",
    key: "templateName",
  },
  {
    title: "Số điện thoại",
    dataIndex: "dataJson",
    key: "name",
    render: (text, record) => {
      const data = JSON.parse(record.dataJson);
      return data.phoneNumber;
    },
  },
  {
    title: "Tạo bởi",
    dataIndex: "createdBy",
    key: "createdBy",
  },
  {
    title: "Ngày tạo",
    dataIndex: "createdDate",
    key: "createdDate",
    align: "center",
    render: (text, record) => {
      return formatDateToString(record.createdDate, "HH:mm:ss-DD/MM/YYYY");
    },
  },
  {
    title: "Lý do từ chối",
    dataIndex: "customerRejectionReason",
    key: "customerRejectionReason",
    align: "center",
    render: (text, record) => {
      return record.customerRejectionReason || record.adminRejectionReason;
    },
  },
  {
    title: "Trạng thái",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (text, record) => {
      switch (record.status) {
        case STATUS.APPROVED:
          return <span style={{ color: "green" }}>Đã đuyệt</span>;
        // case "DRAFT":
        //   return <span style={{ color: "gray" }}>Bản nháp</span>;
        case STATUS.DELETED:
          return <span style={{ color: "red" }}>Đã xóa</span>;
        case STATUS.REJECTED:
          return <span style={{ color: "gray" }}>Từ chối duyệt</span>;
        case STATUS.PENDING:
          return <span style={{ color: "blue" }}>Đang chờ duyệt</span>;
        case STATUS.STUDENT_SIGNED:
          return <span style={{ color: "orange" }}>KH đã ký</span>;
        default:
          return <span>{record.status}</span>;
      }
    },
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    align: "center",
  },
];

const dataFindContract = [
  {
    type: INPUT,
    label: "Từ khóa tên hợp đồng",
    name: "keyword",
  },
  {
    type: COMBO_BOX,
    label: "Trạng thái",
    name: "status",
    options: [
      { label: "Đang chờ duyệt", value: STATUS.PENDING },
      { label: "Từ chối duyệt", value: STATUS.REJECTED },
      { label: "Đã duyệt", value: STATUS.APPROVED },
      { label: "Khách hàng đã ký", value: STATUS.STUDENT_SIGNED },
      { label: "SEC đã ký", value: STATUS.SEC_SIGNED },
      { label: "Hoàn thành", value: STATUS.COMPLETED },
      { label: "Đã xóa", value: STATUS.DELETED },
    ],
  },
  {
    type: INPUT,
    label: "Tạo bởi",
    name: "createdBy",
  },
  {
    type: DATE,
    label: "Ngày từ",
    name: "startDate",
  },
  {
    type: DATE,
    label: "Ngày đến",
    name: "endDate",
  },
  {
    type: SELECT,
    label: "Trưởng nhóm",
    name: "leadTeam",
  },
];

export {
  fieldsPatient,
  listColumnsTableCreated,
  // dataInfoStudent,
  dataFormReason,
  dataFindContract,
};
